import React from "react";

export function TabButtons({ activeTab, onTabChange }) {
  return (
    <div className="tabs">
      <button
        className={`tab-btn ${activeTab === "tablero" ? "active" : ""}`}
        onClick={() => onTabChange("tablero")}
      >
        Tablero
      </button>
      <button
        className={`tab-btn ${activeTab === "resumen" ? "active" : ""}`}
        onClick={() => onTabChange("resumen")}
      >
        Resumen con IA
      </button>
    </div>
  );
}
